import green from "@material-ui/core/colors/green"
import { darken } from "@material-ui/core/styles"

const styles = theme => ({
  shootsSection: {
    display: "flex",
    padding: 32,
    width: "100%",
  },
  shootsSectionWrapper: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
  },
  shootCardWrapper: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionCard: {
    maxWidth: 300,
    flexGrow: 0,
    flexShrink: 0,
    textAlign: "left",
  },
  toggleZoomWrapper: {
    position: "relative",
    height: 24,
    width: 24,
  },
  calendarToggleIcon: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  calendarToggleView: {
    marginRight: theme.spacing(1),
  },
  statusIndicator: {
    backgroundColor: theme.palette.grey[500],
    width: 12,
    height: 12,
    borderRadius: 6,
    display: "inline-block",
    top: 1,
    position: "relative",
  },
  openIndicator: {
    backgroundColor: theme.palette.secondary.main,
  },
  bookedIndicator: {
    backgroundColor: darken(theme.palette.primary.main, 0.2),
  },
  wrappedIndicator: {
    backgroundColor: green[400],
  },
  cancelledIndicator: {
    backgroundColor: "#9e9e9e",
  },
  billedIndicator: {
    backgroundColor: "#966dd3",
  },
  eventPopover: {
    pointerEvents: "none",
  },
  eventPopoverPaper: {
    padding: theme.spacing(1),
  },
  eventPopoverTitle: {
    fontSize: "0.8rem",
  },
  roleTitle: {
    fontSize: "0.6rem",
    color: theme.palette.grey[600],
  },
  placeWrapper: {
    display: "flex",
    alignItems: "center",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  sortChildrenWrapper: {
    marginRight: 32,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sortBy: {
    marginRight: 16,
    fontWeight: "600",
  },
  sortOption: {
    color: theme.palette.primary.dark,
    cursor: "pointer",
  },
  sortOptionDisabled: {
    color: theme.palette.grey[500],
    cursor: "not-allowed",
  },
  sortOptionWrapper: {
    display: "flex",
    marginRight: 16,
  },
  filterButton: {
    marginLeft: 8,
  },
  closeIcon: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
  },
  closeAvatar: {
    backgroundColor: "white",
    border: `2px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
  },
  selected: {
    fontWeight: "600",
  },
  unselected: {
    color: "grey",
  },
  filterSeperator: {
    width: 1,
    height: 40,
    backgroundColor: theme.palette.divider,
    margin: `0 ${theme.spacing(1)}px`,
  },
  dayHeaderFix: {
    "& div > a": {
      color: "black",
    },
  },
  dayCellFix: {
    "& div > div > a": {
      color: "black",
    },
  },
  popoverBlurDiv: {
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: 1,
  },
  customPopover: {
    zIndex: 2,
    background: "white",
    borderRadius: 4,
    position: "absolute",
    transition: "opacity 300ms ease-in-out",
    padding: 4,
    cursor: "pointer",
  },

  resultsWrapper: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(3),
    animationName: "fadeIn",
    animationDuration: theme.transitions.duration.shortest,
    animationDelay: 500,
    animationFillMode: "forwards",
    backgroundColor: "#f8f8f8",
  },
  resultsNumber: {
    fontFamily: '"Oswald"',
    fontWeight: 400,
    fontSize: 34,
    marginRight: theme.spacing(1),
    lineHeight: "0.9em",
  },
  resultsText: {
    width: 70,
    textAlign: "left",
    lineHeight: "1em",
  },
  legendButton: {
    position: "fixed",
    bottom: "83px",
    right: "20px",
    zIndex: 5,
  },
})

export default styles
